import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#F2F4F7] text-[#555555]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <h3 className="text-[#2F6FE4] text-xl font-bold mb-4">The Broker Marketplace</h3>
            <p className="text-[#555555] text-sm leading-relaxed">
              Wholesale Business Credit Services for Brokers. Scale your business with our done-for-you fulfillment platform.
            </p>
          </div>

          <div>
            <h4 className="text-[#2F6FE4] text-sm font-semibold uppercase mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/how-it-works" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">How It Works</Link></li>
              <li><Link to="/services" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">Services</Link></li>
              <li><Link to="/broker-partnership" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">Broker Partnership</Link></li>
              <li><Link to="/submit-deal" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">Submit a Deal</Link></li>
              <li><a href="#apply" className="text-[#555555] hover:text-[#2F6FE4] transition-colors text-sm cursor-pointer">Apply</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#2F6FE4] text-sm font-semibold uppercase mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-[#555555] text-sm">Wholesale Trade Lines</li>
              <li className="text-[#555555] text-sm">Done For You Fulfillment</li>
              <li className="text-[#555555] text-sm">Broker Support</li>
              <li className="text-[#555555] text-sm">Client Processing</li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#2F6FE4] text-sm font-semibold uppercase mb-4">Contact</h4>
            <p className="text-[#555555] text-sm mb-4">info@thebrokermarketplace.com</p>
            <div className="flex space-x-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-[#3D8BFF] hover:text-[#2F6FE4] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-[#3D8BFF] hover:text-[#2F6FE4] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center text-[#3D8BFF] hover:text-[#2F6FE4] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © 2025 The Broker Marketplace. All rights reserved.
            </p>
            
            <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-600 hover:text-[#2F6FE4] transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="text-gray-600 hover:text-[#2F6FE4] transition-colors cursor-pointer">
                Terms and Conditions
              </Link>
              <div className="flex items-center gap-2 text-gray-600">
                <span>Questions before becoming a broker?</span>
                <a
                  href="https://calendar.app.google/gHXojhhUdSU7koyR7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2F6FE4] hover:text-[#1a5cd4] font-semibold transition-colors cursor-pointer"
                >
                  Schedule Intro Call
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;